import { rules2025_26 } from './2025-26.js';
import { rules2026_27 } from './2026-27.js';
/**
 * Rule-set registry: maps a tax-year START year (e.g. 2026 for 2026/27) to its
 * versioned, immutable `TaxRuleSet`. Rule sets are versioned by tax year so a
 * historical projection always re-runs under the rules that were current when
 * it was produced — never mutate a prior year's file; add a new one and
 * register it here.
 */
export const RULE_SETS_BY_START_YEAR = {
    2025: rules2025_26,
    2026: rules2026_27,
};
/** The most recent tax year this package ships rules for (by start year). */
export const LATEST_RULE_SET_START_YEAR = 2026;
/** The oldest tax year this package ships rules for (by start year). */
export const EARLIEST_RULE_SET_START_YEAR = 2025;
/** "2026" → "2026/27", the display form used everywhere a rule set is named. */
export function formatTaxYearLabel(startYear) {
    return `${String(startYear)}/${String((startYear + 1) % 100).padStart(2, '0')}`;
}
/**
 * The shipped rule set NEAREST to a start year: exact when the year is
 * shipped, otherwise clamped to the earliest/latest shipped year. For callers
 * that need a rule-set identity for stamping or display and must not crash on
 * a year outside the shipped range (e.g. a legacy scenario dated 2030). Any
 * caller actually CALCULATING tax must use `rulesForTaxYear` and fail closed.
 */
export function nearestShippedRuleSet(startYear) {
    const clamped = Math.min(Math.max(startYear, EARLIEST_RULE_SET_START_YEAR), LATEST_RULE_SET_START_YEAR);
    return rulesForTaxYear(clamped);
}
/**
 * Select the rule set for a tax year by its start year. Throws for an
 * unknown/unshipped year rather than silently falling back — a missing rule set
 * must never be treated as £0 (mirrors the `assertReviewed` fail-closed stance).
 */
export function rulesForTaxYear(startYear) {
    const rules = RULE_SETS_BY_START_YEAR[startYear];
    if (!rules) {
        const shipped = Object.keys(RULE_SETS_BY_START_YEAR).join(', ');
        throw new Error(`No tax rule set for tax year starting ${startYear}. Shipped years: ${shipped}.`);
    }
    return rules;
}
export { rules2025_26 } from './2025-26.js';
export { rules2026_27, TAX_RULES_VERSION_2026_27 } from './2026-27.js';
//# sourceMappingURL=index.js.map